import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/de-at/messages';
import { messages as retailMessages } from '../translations/autohero-common/de-at/messages';

activateI18n('de-AT', {
  ...retailMessages,
  ...sellOnlyMessages,
});
